import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class ApiService {
  constructor(private httpClient: HttpClient, private router: Router) { }

  urlApi: string = environment.apiUrl;
  urlApiAuth: string = environment.apiUrl;

  getQuery(query: string) {
    const url = `${this.urlApi + query}`;
    return this.httpClient.get(url);
  }
  postQuery(query: string, params: any) {
    const url = `${this.urlApi + query}`;
    return this.httpClient.post(url, params);
  }
  postQueryBlob(endpoint: string, data: object) {
    return this.httpClient.post(`${this.urlApi + endpoint}`, data, {
      responseType: 'text',
      observe: 'response'
    });
  }
  AuthpostQuery(query: string, params: any) {
    const url = `${this.urlApi + query}`;
    return this.httpClient.post(url, params);
  }
  getIniciarSesion(data: object) {
    return this.AuthpostQuery("login", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getDatosUsuario(data: object) {
    return this.postQuery("me", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getFileUrl(filePath: string): string {
    return `${this.urlApi}getfile?file_path=${encodeURIComponent(filePath)}`;
  }
  getFile(data: object) {
    return this.postQueryBlob('getfile', data).pipe(map((res) => res));
  }
  isLogged() {
    let user_sess = sessionStorage.getItem("usu_id");
    return user_sess != null ? true : false;
  }
  validateSession(ruta: string) {
    if (this.isLogged()) {
      if (ruta == "login") {
        this.router.navigate(["login"]);
      } else {
        this.router.navigate([ruta]);
      }
    } else {
      this.router.navigate(["login"]);
    }
  }
  getactualizarCredencialPide(data: object) {
    return this.postQuery("seguridad/actualizarcredencialpide", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  ssoLogin(data: object) {
    return this.postQuery("seguridad/ssoLogin", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getSeguridadperfilusuarioobjetosel(data: object) {
    return this.postQuery("seguridad/perfilusuarioobjetosel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getusuariocambiocontrasena(data: object) {
    return this.postQuery("seguridad/cambiarclave", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrocabsel(data: object) {
    return this.postQuery("fedatario/librocabsel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrocabvigsel(data: object) {
    return this.postQuery("fedatario/librocabvigsel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrocablis(data: object) {
    return this.postQuery("fedatario/librocablis", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getestadolibrossel(data: object) {
    return this.postQuery("fedatario/estadolibrossel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getestadotramitessel(data: object) {
    return this.postQuery("fedatario/estadotramitessel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getdocumentossel(data: object) {
    return this.postQuery("fedatario/documentossel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  gettramitesel(data: object) {
    return this.postQuery("fedatario/tramitesel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfedatariogra(data: object) {
    return this.postQuery("fedatario/fedatariogra", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfedatarioreg(data: object) {
    return this.postQuery("fedatario/fedatarioreg", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrocabreg(data: object) {
    return this.postQuery("fedatario/librocabreg", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getnumeroregistroreg(data: object) {
    return this.postQuery("fedatario/numeroregistroreg", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetlis(data: object) {
    return this.postQuery("fedatario/librodetlis", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetsel(data: object) {
    return this.postQuery("fedatario/librodetsel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetgra(data: object) {
    return this.postQuery("fedatario/librodetgra", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetanu(data: object) {
    return this.postQuery("fedatario/librodetanu", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetcnf(data: object) {
    return this.postQuery("fedatario/librodetcnf", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetcus(data: object) {
    return this.postQuery("fedatario/librodetcus", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getnumeroregistrosel(data: object) {
    return this.postQuery("fedatario/numeroregistrosel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getnumeroregistroupd(data: object) {
    return this.postQuery("fedatario/numeroregistroupd", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  gettrazabilidadreg(data: object) {
    return this.postQuery("fedatario/trazabilidadreg", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfedatariomovimientoreg(data: object) {
    return this.postQuery("fedatario/fedatariomovimientoreg", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfedatariomovimientosel(data: object) {
    return this.postQuery("fedatario/fedatariomovimientosel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getareadenominacionsel(data: object) {
    return this.postQuery("area/areadenominacionsel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetcnfanu(data: object) {
    return this.postQuery("fedatario/librodetcnfanu", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetcusanu(data: object) {
    return this.postQuery("fedatario/librodetcusanu", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrodetcer(data: object) {
    return this.postQuery("fedatario/librodetcer", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getlibrocabcer(data: object) {
    return this.postQuery("fedatario/librocabcer", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getconsultadni(data: object) {
    return this.postQuery("reniec/consultadni", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getconsultaruc(data: object) {
    return this.postQuery("sunat/consultaruc", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getmastertipodocidesel(data: object) {
    return this.postQuery("master/tipodocidesel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  gettrazabilidadsel(data: object) {
    return this.postQuery("fedatario/trazabilidadsel", data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfilebase64(data: object) {
    return this.postQuery('files/base64-from-path', data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getfileurl(data: object) {
    return this.postQuery('files/getfileurl', data).pipe(
      map((data) => {
        return data;
      })
    );
  }
  //DESDE AQUI SE AGREGAN LAS RUTAS
  salonDashboard(data: object) {
    return this.postQuery("salon/dashboard", data).pipe(map((data) => data));
  }
  salonCatalogo(data: object) {
    return this.postQuery("salon/catalogo", data).pipe(map((data) => data));
  }
  salonClienteGra(data: object) {
    return this.postQuery("salon/clientegra", data).pipe(map((data) => data));
  }
  salonClienteLis(data: object) {
    return this.postQuery("salon/clientelis", data).pipe(map((data) => data));
  }
  salonTrabajadorGra(data: object) {
    return this.postQuery("salon/trabajadorgra", data).pipe(map((data) => data));
  }
  salonTrabajadorLis(data: object) {
    return this.postQuery("salon/trabajadorlis", data).pipe(map((data) => data));
  }
  salonTrabajadorEstado(data: object) {
    return this.postQuery("salon/trabajadorestado", data).pipe(map((data) => data));
  }
  salonServicioGra(data: object) {
    return this.postQuery("salon/serviciogra", data).pipe(map((data) => data));
  }
  salonServicioLis(data: object) {
    return this.postQuery("salon/serviciolis", data).pipe(map((data) => data));
  }
  salonProductoGra(data: object) {
    return this.postQuery("salon/productogra", data).pipe(map((data) => data));
  }
  salonProductoLis(data: object) {
    return this.postQuery("salon/productolis", data).pipe(map((data) => data));
  }
  salonCajaAbrir(data: object) {
    return this.postQuery("salon/cajaabrir", data).pipe(map((data) => data));
  }
  salonCajaEstado(data: object) {
    return this.postQuery("salon/cajaestado", data).pipe(map((data) => data));
  }
  salonCajaCerrar(data: object) {
    return this.postQuery("salon/cajacerrar", data).pipe(map((data) => data));
  }
  salonCajaConformidad(data: object) {
    return this.postQuery("salon/cajaconformidad", data).pipe(map((data) => data));
  }
  salonCajaReaperturar(data: object) {
    return this.postQuery("salon/cajareaperturar", data).pipe(map((data) => data));
  }
  salonCajaCierreTicket(data: object) {
    return this.postQuery("salon/cajacierreticket", data).pipe(map((data) => data));
  }
  salonCajaEgreso(data: object) {
    return this.postQuery("salon/cajaegreso", data).pipe(map((data) => data));
  }
  salonCajaIngreso(data: object) {
    return this.postQuery("salon/cajaingreso", data).pipe(map((data) => data));
  }
  salonVentaReg(data: object) {
    return this.postQuery("salon/ventareg", data).pipe(map((data) => data));
  }
  salonAtencionReg(data: object) {
    return this.postQuery("salon/atencionreg", data).pipe(map((data) => data));
  }
  salonAtencionServiciosAgregar(data: object) {
    return this.postQuery("salon/atencionserviciosagregar", data).pipe(map((data) => data));
  }
  salonAtencionLis(data: object) {
    return this.postQuery("salon/atencionlis", data).pipe(map((data) => data));
  }
  salonAtencionDetalleLis(data: object) {
    return this.postQuery("salon/atenciondetallelis", data).pipe(map((data) => data));
  }
  salonAtencionEstadoUpd(data: object) {
    return this.postQuery("salon/atencionestadoupd", data).pipe(map((data) => data));
  }
  salonAtencionPagar(data: object) {
    return this.postQuery("salon/atencionpagar", data).pipe(map((data) => data));
  }
  salonReporteTrabajador(data: object) {
    return this.postQuery("salon/reportetrabajador", data).pipe(map((data) => data));
  }
  salonReporteCaja(data: object) {
    return this.postQuery("salon/reportecaja", data).pipe(map((data) => data));
  }
  salonReporteRentabilidad(data: object) {
    return this.postQuery("salon/reporterentabilidad", data).pipe(map((data) => data));
  }
  salonUsuarioLis(data: object) {
    return this.postQuery("salon/usuariolis", data).pipe(map((data) => data));
  }
  salonUsuarioGra(data: object) {
    return this.postQuery("salon/usuariogra", data).pipe(map((data) => data));
  }
  salonUsuarioEstado(data: object) {
    return this.postQuery("salon/usuarioestado", data).pipe(map((data) => data));
  }
  salonRolesLis(data: object = {}) {
    return this.postQuery("salon/roleslis", data).pipe(map((data) => data));
  }
  salonOperacionesLis(data: object) {
    return this.postQuery("salon/operacioneslis", data).pipe(map((data) => data));
  }
  salonOperacionModificar(data: object) {
    return this.postQuery("salon/operacionmodificar", data).pipe(map((data) => data));
  }
  salonVentaDetalleSel(data: object) {
    return this.postQuery("salon/ventadetallesel", data).pipe(map((data) => data));
  }
  salonVentaModificarPos(data: object) {
    return this.postQuery("salon/ventamodificarpos", data).pipe(map((data) => data));
  }
  salonAuditoriaLis(data: object) {
    return this.postQuery("salon/auditorialis", data).pipe(map((data) => data));
  }

}
